import { setStatusBarHeight } from 'freedom-shared';

export const withStatusBarHeight = () => {
  setStatusBarHeight();
};
